/**
 * Hospital-side API client + auth utilities for the Emergency Dispatch Console.
 *
 * Uses a separate token key (`rescigo_emdispatch_token`) so hospital users
 * signing in don't collide with staff/customer sessions in the same browser.
 */
import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EMD_TOKEN_KEY = "rescigo_emdispatch_token";

export const emdApi = axios.create({
  baseURL: BASE,
  headers: { "Content-Type": "application/json" },
});

emdApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(EMD_TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

emdApi.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    if (status === 401 && window.location.pathname.startsWith("/emdispatch")
        && !window.location.pathname.endsWith("/login")) {
      localStorage.removeItem(EMD_TOKEN_KEY);
      window.location.href = "/emdispatch/login";
    }
    return Promise.reject(err);
  },
);

export function emdLogout() {
  localStorage.removeItem(EMD_TOKEN_KEY);
  window.location.href = "/emdispatch/login";
}

export function formatEmdError(err) {
  return err?.response?.data?.detail || err?.message || "Something went wrong";
}
